// src/components/layout/SuperHeader.jsx
import React from "react";
import AdminPortalHeader from "./AdminPortalHeader";

const SuperHeader = ({ onMenuToggle }) => (
  <AdminPortalHeader
    onMenuToggle={onMenuToggle}
    roleLabel="Super Admin"
    profilePath="/superadmin/profile"
    settingsPath="/superadmin/settings"
    activityLogPath="/superadmin/activity-log"
  />
);

export default SuperHeader;
